import { render } from "./List.vue?vue&type=template&id=4a3bdd00"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Tags/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a3bdd00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a3bdd00', __exports__)) {
    api.reload('4a3bdd00', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=4a3bdd00", () => {
    api.rerender('4a3bdd00', render)
  })

}


export default __exports__